import cn from 'classnames';
import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useCurrency } from 'dibs-buyer-layout/exports/useCurrency';

// components
import { SeoLink } from 'dibs-seo/exports/SeoLink';

// styles
import dibsCss from 'dibs-css';
import styles from './SbRespHolidayGiftCollectionLinks.module.css';

// types
import { type SbRespHolidayGiftCollectionLinks_browseContentModule$key as BrowseContentModule } from './__generated__/SbRespHolidayGiftCollectionLinks_browseContentModule.graphql';

const images = [
    'https://a.1stdibscdn.com/dist/adhoc/holiday-gift-guide/tile_1_11-25-25.jpg?disable=upscale&auto=webp&quality=60',
    'https://a.1stdibscdn.com/dist/adhoc/holiday-gift-guide/tile_2_11-25-25.jpg?disable=upscale&auto=webp&quality=60',
    'https://a.1stdibscdn.com/dist/adhoc/holiday-gift-guide/tile_3_11-25-25.jpg?disable=upscale&auto=webp&quality=60',
    'https://a.1stdibscdn.com/dist/adhoc/holiday-gift-guide/tile_4_11-25-25.jpg?disable=upscale&auto=webp&quality=60',
    'https://a.1stdibscdn.com/dist/adhoc/holiday-gift-guide/tile_5_11-25-25.jpg?disable=upscale&auto=webp&quality=60',
];

const browseContentModuleFragment = graphql`
    fragment SbRespHolidayGiftCollectionLinks_browseContentModule on ContentModuleBannerTiles {
        tiles {
            title
            linkData {
                ...SeoLink_linkData
            }
            localizedLinkDataList {
                currency
                linkData {
                    ...SeoLink_linkData
                }
            }
        }
    }
`;

export const SbRespHolidayGiftCollectionLinks: FC<{
    browseContentModule: BrowseContentModule;
}> = ({ browseContentModule: browseContentModuleRef }) => {
    const browseContentModule = useFragment(browseContentModuleFragment, browseContentModuleRef);
    const { currency } = useCurrency();
    const { tiles } = browseContentModule || {};

    return (
        <div
            className={cn(
                dibsCss.flex,
                dibsCss.wFull,
                dibsCss.pyLarge,
                dibsCss.pxLarger,
                dibsCss.gapSmaller,
                dibsCss.sassyFontHeaderSmall,
                styles.container
            )}
        >
            {tiles?.map((tile, index) => {
                const { title, linkData: tileLinkData, localizedLinkDataList } = tile || {};
                const localizedLinkData = localizedLinkDataList?.find(
                    item => item?.currency === currency
                );
                const linkData = localizedLinkData?.linkData || tileLinkData;
                return title && linkData ? (
                    <SeoLink
                        key={index}
                        linkData={linkData}
                        className={cn(
                            dibsCss.flex1,
                            dibsCss.relative,
                            dibsCss.overflowHidden,
                            dibsCss.roundedXxsmall,
                            styles.tile
                        )}
                    >
                        <img
                            alt={title}
                            src={images[index]}
                            className={cn(dibsCss.objectCover, dibsCss.hFull, dibsCss.wFull)}
                        />
                        <span
                            className={cn(
                                dibsCss.flex,
                                dibsCss.wFull,
                                dibsCss.left0,
                                dibsCss.pSmall,
                                dibsCss.bottom0,
                                dibsCss.itemsEnd,
                                dibsCss.absolute,
                                styles.title
                            )}
                        >
                            {title}
                        </span>
                    </SeoLink>
                ) : null;
            })}
        </div>
    );
};
